import apiCall from './call'

const model = 'accounts'

const state = {
  recent: {},
  favorites: {},
  invited: {},
  statuses: [],
  statusCounts: {},
  initialized: false,
  any: false // tracks if user has any accounts at all
}

const getters = {
  //
}

const actions = {
  getRecentlyActiveAccounts ({ commit }) {
    commit('setLoadingState')
    return new Promise((resolve, reject) => {
      let queryString = {
        'order': 'desc',
        'sort': 'updated_at',
        'filter__favorites': 0
      }
      apiCall({ url: model, qs: queryString })
        .then(response => {
          commit('setAccounts', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          commit('setAccounts', {})
        })
    })
  },
  getFavoriteAccounts ({ commit }) {
    commit('setLoadingState')
    return new Promise((resolve, reject) => {
      let queryString = {
        'order': 'desc',
        'sort': 'updated_at',
        'paginate': 9999,
        'filter__favorites': 1
      }
      apiCall({ url: model, qs: queryString })
        .then(response => {
          commit('setFavoriteAccounts', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          commit('setFavoriteAccounts', {})
        })
    })
  },
  getInvitedAccounts ({ commit }) {
    commit('setLoadingState')
    return new Promise((resolve, reject) => {
      let queryString = {
        'order': 'desc',
        'sort': 'updated_at',
        'filter__invites': 1
      }
      apiCall({ url: model, qs: queryString })
        .then(response => {
          commit('setInvitedAccounts', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
          commit('setInvitedAccounts', {})
        })
    })
  },
  getAccountStatuses ({ commit }) {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'statuses/' + model })
        .then(response => {
          commit('setStatuses', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getStatusCounts ({ commit }) {
    return new Promise((resolve, reject) => {
      apiCall({ url: 'metrics/' + model + '/summary' })
        .then(response => {
          commit('setStatusCounts', response.data)
          resolve(response)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  setAccount ({ commit }, accountObj) {
    commit('setAccount', accountObj)
  }
}

const mutations = {
  setAccounts (state, accounts) {
    state.recent = accounts
    state.initialized = true
    state.any = true
  },
  setFavoriteAccounts (state, accounts) {
    state.favorites = accounts
    state.any = true
  },
  setInvitedAccounts (state, accounts) {
    state.invited = accounts
    state.any = true
  },
  setAccount (state, accountObj) {
    let totalAccounts = Object.keys(state.recent).length
    let index = 0
    let favoritesIndex = 0

    if (totalAccounts > 0) {
      state.any = true

      for (let accountIndex in state.recent) {
        if (!state.recent.hasOwnProperty(accountIndex)) continue
        if (parseInt(state.recent[accountIndex].id) === parseInt(accountObj.account.id)) {
          index = accountIndex
        }
      }

      for (let accountIndex in state.favorites) {
        if (!state.favorites.hasOwnProperty(accountIndex)) continue
        if (parseInt(state.favorites[accountIndex].id) === parseInt(accountObj.account.id)) {
          favoritesIndex = accountIndex
        }
      }

      if (index === 0) index = totalAccounts++
    }

    state.recent = { ...state.recent, [index]: accountObj.account }

    if (favoritesIndex !== 0) {
      state.favorites = { ...state.favorites, [favoritesIndex]: accountObj.account }
    }
  },
  setStatuses (state, statuses) {
    state.statuses = statuses
  },
  setStatusCounts (state, statusCounts) {
    state.statusCounts = statusCounts
  },
  setLoadingState (state) {
    if (Object.keys(state.recent).length > 0) {
      // Populated via loading accounts before getting to dashboard
      state.initialized = true
      return
    }

    // Already loading once
    if (state.initialized === true) return

    state.initialized = false
    state.any = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/accounts.js